<template>
  <div class="trainingCourseAdmin">
    <el-button size="small" type="primary" @click="addCurriculum" icon="el-icon-plus">添加培训课程</el-button>
    <el-form class="form-style" :inline="true" size="small">
      <el-form-item label="活动名称:">
        <el-input v-model="title" clearable placeholder="请输入活动名称"></el-input>
      </el-form-item>
      <el-form-item label="所属科目:">
        <el-select v-model="subject_id" clearable placeholder="请选择所属科目">
          <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发布状态:">
        <el-select v-model="post_state" clearable placeholder="请选择发布状态">
          <el-option label="全部" value></el-option>
          <el-option label="已发布" value="1"></el-option>
          <el-option label="未发布" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="search" type="primary">搜索</el-button>
      </el-form-item>
    </el-form>

    <div class="table-style">
      <el-table size="small" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column align="center" width="120" type="index" label="序号"></el-table-column>

        <el-table-column align="center" width="100" label="封面">
          <template slot-scope="scope">
            <el-image style="width: 40px; height: 18px" :src="scope.row.img_url" fit="fill"></el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" prop="subjectName" label="科目"></el-table-column>
        <el-table-column align="center" prop="title" label="标题"></el-table-column>
        <el-table-column align="center" prop="tch_num" label="观看人数">
          <template slot-scope="scope">
            <!-- <span @click="readerList(scope.row)">{{scope.row.tch_num}}</span> -->
            <el-link @click="readerList(scope.row)">{{ scope.row.tch_num }}</el-link>

            <!-- <el-button size="small" @click="readerList(scope.row)">查看信息</el-button> -->
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="观看列表">
          <template slot-scope="scope">
            <el-button size="small" @click="readerList(scope.row)">查看信息</el-button>
          </template>
        </el-table-column>-->

        <el-table-column align="center" label="操作" width="350px">
          <template slot-scope="scope">
            <el-button size="small" @click="editbtn(scope.row)" type="text">修改</el-button>
            <el-button size="small" @click="overallClick(scope.row)" type="text">添加课程章节</el-button>

            <el-button type="text" size="small" @click="isState(scope.row)"
              v-if="scope.row.is_post === false">发布</el-button>
            <el-button type="text" size="small" @click="isState1(scope.row)"
              v-if="scope.row.is_post === true">取消发布</el-button>

            <el-button size="small" type="text" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-style">
      <el-pagination @current-change="handleCurrentChange" :current-page="page_no" layout="total, prev, pager, next"
        :total="total" :page-size="page_size"></el-pagination>
    </div>

    <!-- 获取弹窗列表 -->
    <el-dialog title="观看信息" :visible.sync="dialogVisible">
      <el-table :data="tableDataDialog" style="width: 100%" height="500">
        <el-table-column prop="created_time" label="观看日期"></el-table-column>
        <el-table-column prop="schoolName" label="校区"></el-table-column>
        <el-table-column label="姓名">
          <!-- <template scope="scope">{{user.realname}}</template> -->
          <template slot-scope="scope">{{ scope.row.userInfo.realname }}</template>
        </el-table-column>
        <el-table-column label="电话">
          <!-- <template>{{user.phone_num}}</template> -->
          <template slot-scope="scope">{{ scope.row.userInfo.phone_num }}</template>
        </el-table-column>
      </el-table>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent" :current-page="page1_no" :page-size="page1_size"
          layout="total, prev, pager, next" :total="total1"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAdminSubjectListWithOutPageInfo,
  getList,
  isState,
  delTraining,
  readerList
} from "@/api/admin.js";
export default {
  data() {
    return {
      tch_training_id: "",
      user: {},
      tableDataDialog: [],
      dialogVisible: false,
      total1: 0,
      page1_no: 1,
      page1_size: 20,
      total: 0,
      page_no: 1,
      page_size: 20,
      title: "",
      subject_id: "",
      post_state: "",
      subjectList: [],
      tableData: []
    };
  },
  created() {
    this.getAdminSubjectListWithOutPageInfo();
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleCurrent(val) {
      this.page1_no = val;
      console.log(this.tch_training_id);
      readerList({
        tch_training_id: this.tch_training_id,
        page_no: this.page1_no,
        page_size: this.page1_size
      }).then(res => {
        console.log(res);
        this.tableDataDialog = res.tchTrainingReaderList;
        this.total1 = res.total;
      });
    },
    overallClick(row) {
      console.log(row);
      this.$router.push({
        name: "catalogue",
        query: {
          id: row.id
        }
      });
    },
    //获取观看信息
    readerList(row) {
      this.dialogVisible = true;
      readerList({
        tch_training_id: row.id,
        page_no: this.page1_no,
        page_size: this.page1_size
      }).then(res => {
        console.log(res);
        this.tableDataDialog = res.tchTrainingReaderList;
        this.total1 = res.total;
        let a = row.id;
        this.tch_training_id = a;
        console.log(a);
      });
    },
    //是否发布
    isState(row) {
      this.$confirm("是否发布?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          isState({
            tch_training_id: row.id,
            is_post: 1
          }).then(() => {
            this.$message({
              type: "success",
              message: "发布成功!"
            });
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消发布"
          });
        });
    },
    isState1(row) {
      this.$confirm("是否取消发布?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          isState({
            tch_training_id: row.id,
            is_post: 0
          }).then(() => {
            this.$message({
              type: "success",
              message: "取消发布成功!"
            });
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作"
          });
        });
    },
    //获取列表
    getList() {
      getList({
        title: this.title,
        subject_id: this.subject_id,
        page_no: this.page_no,
        post_state: this.post_state,
        page_size: this.page_size
      }).then(res => {
        console.log(res);
        this.tableData = res.tchTrainingList;
        this.total = res.total;
      });
    },
    handleCurrentChange(val) {
      this.page_no = val;
      this.getList();
    },
    //获取科目
    getAdminSubjectListWithOutPageInfo() {
      getAdminSubjectListWithOutPageInfo(
        {
          subject_state: 1
        }
      ).then(res => {
        console.log(res);
        this.subjectList = res.subject_list;
      });
    },
    // 添加
    addCurriculum() {
      this.$router.push({
        name: "add-training-course-admin",
        query: {
          act: "add"
        }
      });
    },
    //编辑
    editbtn(row) {
      this.$router.push({
        name: "add-training-course-admin",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    //删除
    del(row) {
      this.$confirm("确定删除当前课程?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        delTraining(
          {
            tch_training_id: row.id
          },
          true
        ).then(() => {
          this.$message.success("删除成功！");
          this.getList();
        });
      });
    },
    //检索
    search() {
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.trainingCourseAdmin {
  height: 100%;
  min-height: 100vh;
  background-color: #fff;
  margin: 15px;
  padding: 15px;

  .form-style {
    margin-left: 15px;
  }

  .table-style {
    margin-top: 15px;
    cursor: pointer;
  }
}
</style>